import { Button, Grid, Typography } from "@mui/material";
import React from "react";

const GenericButtons = ({
  quantity,
  id,
  index,
  disabledAdd,
  disabledSubtract,
  add,
  subtract,
}: {
  quantity: number;
  id: string;
  index?: number;
  disabledAdd?: boolean;
  disabledSubtract?: boolean;
  add(index?: number): void;
  subtract(id: string, index?: number): void;
}) => (
  <Grid
    size={4}
    display="flex"
    alignItems="center"
    justifyContent="space-evenly"
  >
    <Button
      variant="outlined"
      disabled={disabledSubtract}
      size="small"
      onClick={() => subtract(id, index)}
    >
      -
    </Button>
    <Typography>{quantity || 1}</Typography>
    <Button
      variant="outlined"
      disabled={disabledAdd}
      size="small"
      onClick={() => add(index)}
    >
      +
    </Button>
  </Grid>
);

export default GenericButtons;
